var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cz2__header-bar"},[_c('button',{staticClass:"cz2__header-bar__close",attrs:{"aria-label":_vm.$t('MENU_CLOSE')},on:{"click":function($event){$event.preventDefault();return _vm.$emit('close')}}}),_c('div',{staticClass:"cz2__header-bar__title"},[_vm._v(_vm._s(_vm.$t('MENU_HEADER')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }